import { useQuery } from "@apollo/client"
import { MenuItem } from "@blueprintjs/core"
import StaticMultiSelector from "components/Atoms/StaticMultiSelector"
import { debounce } from "lodash-es"
import React, { useState } from "react"
const SearchMultiSelector = ({ query, first = 20, ...otherProps }) => {
  const [search, setQuery] = useState("")
  const { data, loading } = useQuery(query, {
    variables: { first: 20, query: search },
  })

  const key = data && Object.keys(data)?.[0]
  const list = data?.[key]
  function handleChange(srch) {
    if (srch !== search) setQuery(srch)
  }
  const debouncedChange = debounce(handleChange, 500)

  return (
    <StaticMultiSelector
      loading={loading}
      query={search}
      onSearchChange={debouncedChange}
      items={list}
      itemPredicate={(_, item) => item}
      itemRenderer={(item, { handleClick, modifiers, index }) => {
        return (
          <MenuItem
            active={modifiers.active}
            key={item?.id ?? `item-${index}`}
            onClick={handleClick}
            text={item?.name}
          />
        )
      }}
      {...otherProps}
    />
  )
}

export default SearchMultiSelector
